import React, { useState } from 'react'
import { Form, Input, Button, message, InputNumber } from 'antd'
import {
  createInventoryCategory,
  updateInventoryCategory
} from '../../api/inventory'

const InventoryCategoryForm = ({ onSuccess, category, onCancel }) => {
  const [form] = Form.useForm()
  const [loading, setLoading] = useState(false)

  React.useEffect(() => {
    if (category) {
      form.setFieldsValue({
        name: category.name,
        description: category.description,
        sortOrder: category.sortOrder
      })
    } else {
      form.resetFields()
    }
  }, [category, form])

  const handleFinish = async (values) => {
    setLoading(true)
    try {
      if (category) {
        await updateInventoryCategory(category._id || category.id, values)
        message.success('分類更新成功')
      } else {
        await createInventoryCategory(values)
        message.success('分類新增成功')
      }
      form.resetFields()
      onSuccess?.()
    } catch (error) {
      console.error('分類操作失敗:', error)
      const errorMessage = error.response?.data?.message || '操作失敗'
      message.error(errorMessage)
    }
    setLoading(false)
  }

  return (
    <Form
      form={form}
      onFinish={handleFinish}
      layout='vertical'
      initialValues={{
        sortOrder: 0
      }}
    >
      <Form.Item
        name='name'
        label='分類名稱'
        rules={[{ required: true, message: '請輸入分類名稱' }]}
      >
        <Input placeholder='請輸入分類名稱' />
      </Form.Item>
      <Form.Item name='description' label='分類描述'>
        <Input.TextArea rows={3} placeholder='請輸入分類描述（可選）' />
      </Form.Item>
      <Form.Item name='sortOrder' label='排序順序'>
        <InputNumber
          min={0}
          placeholder='數字越小越靠前'
          style={{ width: '100%' }}
        />
      </Form.Item>
      <Form.Item style={{ marginBottom: 0, marginTop: 24 }}>
        <div
          style={{ display: 'flex', gap: '12px', justifyContent: 'flex-end' }}
        >
          {onCancel && <Button onClick={onCancel}>取消</Button>}
          <Button type='primary' htmlType='submit' loading={loading}>
            {category ? '更新' : '確認新增'}
          </Button>
        </div>
      </Form.Item>
    </Form>
  )
}

export default InventoryCategoryForm
